import { WarningAmberOutlined } from '@mui/icons-material';
import { Box, Typography, alpha } from '@mui/material';
import { memo } from 'react';

import { theme } from 'app/providers/ThemeProvider/config/theme';
import { ColoredLinkBox } from 'shared/ui/ColoredLinkBox';

type PropertyCatalogItemRowProps = {
    name: string;
    value: string | number;
    bordered?: boolean;
    showLinkIcon?: boolean;
    showWarningIcon?: boolean;
};

export const PropertyCatalogItemRow = memo(
    ({
        name,
        value = '',
        bordered,
        showLinkIcon = false,
        showWarningIcon = false,
    }: PropertyCatalogItemRowProps) => {
        return (
            <Box
                p="16px 0"
                display="flex"
                borderBottom={bordered ? '1px solid #E9E8E8' : undefined}
                borderColor="divider"
                justifyContent="space-between"
                alignItems="flex-start"
                data-testclass={`attribute`}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {showWarningIcon && (
                        <WarningAmberOutlined sx={{ color: '#FF9D00' }} />
                    )}
                    <Typography
                        sx={{
                            color: alpha(theme.palette.common.black, 0.5),
                            fontFamily: 'Open Sans',
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '20px',
                            letterSpacing: '0.15px',
                        }}
                        data-testclass="label"
                    >
                        {name}
                    </Typography>
                    {showLinkIcon && (
                        <ColoredLinkBox
                            data-testclass={'operations-account-enabled'}
                            color="#DBEFE1"
                            tooltipText="Supplier activated"
                        />
                    )}
                </Box>
                <Typography
                    maxWidth="340px"
                    textAlign="right"
                    sx={{
                        color: alpha(theme.palette.common.black, 0.85),
                        fontFamily: 'Open Sans',
                        fontSize: '16px',
                        fontWeight: 400,
                        lineHeight: '20px',
                        letterSpacing: '0.15px',
                    }}
                    data-testclass="value"
                >
                    {value}
                </Typography>
            </Box>
        );
    },
);
